import React from 'react';
import { X } from 'lucide-react';
import { format } from 'date-fns';
import { toast } from 'react-hot-toast';
import { removeOfflinePhoto } from '../../../utils/offlineDb';

interface OfflinePhotosProps {
  photos: any[];
  onPhotosUpdated: () => Promise<void>;
}

export function OfflinePhotos({ photos, onPhotosUpdated }: OfflinePhotosProps) {
  if (photos.length === 0) return null;

  return (
    <div className="mt-6">
      <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Offline Photos ({photos.length})
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {photos.map((photo) => (
          <div key={photo.id} className="relative aspect-square">
            <img
              src={URL.createObjectURL(photo.file)}
              alt={`Offline ${photo.id}`}
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-2">
              <p className="truncate">{photo.taskItem}</p>
              <p>{format(photo.timestamp, 'MMM d, HH:mm')}</p>
            </div>
            <button
              onClick={async () => {
                await removeOfflinePhoto(photo.id);
                await onPhotosUpdated();
                toast.success('Offline photo removed');
              }}
              className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}